import React from 'react';
import { BookOpenCheckIcon, CalendarDaysIcon, CheckIcon, ClipboardListIcon, ImageIcon } from 'lucide-react';
const stats = [[BookOpenCheckIcon, '240+', 'Pagine pratiche'], [ClipboardListIcon, '300+', 'Sessioni pronte'], [ImageIcon, '120+', 'Schede visuali'], [CalendarDaysIcon, '6', 'Volumi completi']];
const tags = ['Scuola Primaria', 'Secondaria di I grado', 'Secondaria di II grado', 'Sport di squadra e individuali', 'Giochi e inclusione', 'Valutazione e planner'];
export function SystemSection() {
  return <section className="border-y-4 border-emerald-400 bg-[#10372a] px-5 py-20" data-id="element-211" data-mp="2wrw5g768m82u">
      <div className="mx-auto max-w-6xl text-center" data-id="element-212" data-mp="2ssx38ubw4pf3">
        <p className="inline-block bg-emerald-400 px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#09281d]" data-id="element-213" data-mp="2ntkf869a9cax">
          Il sistema più completo per i docenti di Scienze Motorie
        </p>
        <h2 className="mt-7 font-display text-5xl font-bold uppercase leading-none text-white sm:text-7xl" data-id="element-214" data-mp="2dvee3qvawa74">
          EDUFIS <span className="text-emerald-300" data-id="element-215" data-mp="13yy4te41m1gj">PRONTO</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-slate-300" data-id="element-216" data-mp="18py3oowq2tlo">
          Oltre 240 pagine di piani di lezione, esercizi professionali, giochi,
          guide tecniche e strumenti di gestione della classe —{' '}
          <strong className="text-white" data-id="element-217" data-mp="z0wlqt6ma252">tutto già fatto per te.</strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-218" data-mp="1mqr05f6l3yrf">
          {stats.map(([Icon, value, label]) => <div key={label} className="border border-emerald-300/25 bg-[#09281d] p-6" data-id="element-219" data-mp="1roafyjixkjlh">
              <Icon className="mx-auto h-7 w-7 text-emerald-300" data-id="element-220" data-mp="1ctw0gsykrsbk" />
              <p className="mt-4 font-display text-4xl font-bold text-white" data-id="element-221" data-mp="1hp1obxbjfh2a">
                {value}
              </p>
              <p className="text-xs font-bold uppercase tracking-widest text-slate-300" data-id="element-222" data-mp="1eh862hb9oms">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-4 border border-emerald-300/25 bg-[#09281d] p-7" data-id="element-223" data-mp="28xlc9181zunv">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-white" data-id="element-224" data-mp="23yrzxc4i69pa">
            Copertura totale: dalla Primaria alla Secondaria di II grado
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-225" data-mp="1u98go5cvodtw">
            {tags.map(tag => <span key={tag} className="flex items-center gap-1.5 border border-emerald-300/25 bg-[#10372a] px-3 py-2 text-xs font-bold text-white" data-id="element-226" data-mp="1p9vtfji3h4qs">
                <CheckIcon className="h-3.5 w-3.5 text-emerald-300" data-id="element-227" data-mp="1g97coh1bgqa7" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}